<template>
	<div class="horizontal-center">
		<b-select v-model="year" @input="onChange">
			<option v-if="hasEmptyOption" value="">未選択</option>
			<option
				v-for="row in years"
				:value="row"
				:key="row">
				{{ row }}
			</option>
		</b-select>

		<div v-if="isTextShow">年</div>

		<b-select class="ml-20" v-model="month" @input="onChange">
			<option v-if="hasEmptyOption" value="">未選択</option>
			<option
				v-for="n in 12"
				:value="$utils.zeroPadding(n, 2)"
				:key="n">
				{{ n }}
			</option>
		</b-select>

		<div v-if="isTextShow">月</div>

		<b-select v-if="isDateShow" class="ml-20" v-model="day" @input="onChange">
			<option v-if="hasEmptyOption" value="">未選択</option>
			<option
				v-for="n in 31"
				:value="$utils.zeroPadding(n, 2)"
				:key="n">
				{{ n }}
			</option>
		</b-select>

		<div v-if="isTextShow && isDateShow">日</div>
	</div>
</template>

<style lang="scss" scoped>

</style>

<script>

export default {
	name: 'DateSelect',
	props: {
		dateProvided: {
			type: String,
			default: ''
		},
		years: {
			type: Array,
			default: null,
		},
		hasEmptyOption: {
			type: Boolean,
			default: false,
		},
		isTextShow: {
			type: Boolean,
			default: true,
		},
		isDateShow: {
			type: Boolean,
			default: true,
		},
	},
	components: {
	},
	data: function() {
		return {
			year: null,
			month: null,
			day: null,
		}
	},
	mounted() {
		this.setDate();
	},
	watch: {
		dateProvided: function() {
			this.setDate();
		},
	},
	methods: {
		setDate: function() {
			if (this.dateProvided !== '') {
				let dates = this.dateProvided.split('-');
				this.year = dates[0];
				this.month = dates[1];
				this.day = dates[2];
			} else {
				this.year = '';
				this.month = '';
				this.day = '';
			}
		},
		onChange: function() {
			let date = '';
			if (!(this.year === '' && this.month === '' && this.day === '')) {
				if (this.isDateShow) {
					date = `${this.year}-${this.month}-${this.day}`;
				} else {
					date = `${this.year}-${this.month}`;
				}
			}
			this.$emit('change', date);
		},
	},
}
</script>
